import {Model} from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";
import { getAging, getUserGrantsTextOnly } from "../../other/utils/utils.jsx";

export class User extends HasProjectMixin(Model) {
  static get $name() {
    return "User";
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name", type: "string"  },
      { name: "email", dataSource: "email", type: "string" },
      { name: "role", dataSource: "roles" }, // don't want to persist this as send inv button wil do
      // Todo: fix needed, enabling this statement cause replay effect as the dataSource roles and roles in name somehow conflicts.
      // kind of similar to this issue => https://admin.dev.swivu.com/swivu-engineering-rjv68i/scheduler?task=98539&tab=general
      // { name: "roles", persist: false }, // don't want to persist this as send inv button wil do
      { name: "userId", dataSource: "user_id", type: "number", persist: false },
      { name: "selfContactId", dataSource: "self_contact", type: "number" },
      // Todo: I think we don't need board_id, check it
      { name: "boardId", dataSource: "board_id", type: "number", persist: false },
      { name: "createdAt", dataSource: "created_at", persist: false },
      { name: "aging", persist: false },
      { name: "lastLogin", dataSource: "last_login", persist: false },
      { name: "lastInteractionHQ", dataSource: "last_interaction_hq" },
      // view specific field
      { name: "isGridRowExpanded", persist: false },
      { name: "hasContacts", persist: false },
      { name: "profileImageURL", dataSource: "profile_image_url" },
      { name: "lastInteractionWorkforce", dataSource: "last_interaction_workforce"},
      { name: "delivered", persist: false },
      { name: "roleName", persist: false }
    ]
  }

  static relations = {
    selfContactRecord: { // this will get contact (detail) record of this record
      foreignKey: "selfContactId",
      foreignStore: STORE_KEYS.contactStore,
      relatedCollectionName: "userSelfContact", // this key will be added to the parent to get child records -> contactStore.first.userSelfContact will bring all User records for that contact record
    }
  }

  static swivuGetFieldOriginalSourceName(fieldName) {
    const fieldsMaps = {'roleName': 'roles'}
    return fieldsMaps[fieldName] || super.swivuGetFieldOriginalSourceName?.(fieldName);
  }

  get entityVisibleName() {
    return "User";
  }

  get isDeactivated() {
    // to identify whether user is deactivated, we need to make sure the grant array is empty
    return !this.grants.length;
  }

  get roles() {
    return this.get("role")?.[0]
  }

  set roles(value) {
    if (!this.isGroupHeader) {
      this.set("role", [value])
      this.set("roles", [value])
      this.set("roleName", this.roleName);
    }
  }

  get roleName() {
    if (this.project) {
      const allRoles = this.project.swivuAppRoles;
      return this.roles ? allRoles.find((role) => this.roles === role.id).name: "";
    }
    return "";
  }

  get grants() {
    if (this.roles) {
      const allRoles = this.project.swivuAppRoles;
      return allRoles.find((role) => this.roles === role.id).grants;
    }
    return [];
  }

  get grantsTextOnly() {
    const roleGrants = this.grants;
    return getUserGrantsTextOnly(roleGrants);
  }

  get hasContacts() {
    // For group headers this.contacts will be undefined
    return Boolean(this.contacts?.length)
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }
}

User.exposeProperties();
